import { Box, Typography, Container, Button, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Travel() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 4, maxWidth: '800px !important' }}>
      <Box sx={{ mb: 6 }}>
        {/* Where to fly section */}
        <Box sx={{ 
          bgcolor: 'white', 
          p: 2, 
          borderRadius: 2,
          mb: 4 
        }}>
          <Box sx={{ 
            bgcolor: 'rgba(225, 213, 203, 0.3)',
            p: 1,
            px: 2,
            borderRadius: 20,
            mb: 2,
            width: '100%'
          }}>
            <Typography 
              align="left"
              variant="h5" 
              component="h2"
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontWeight: 'bold'
              }}
            >
              ✈️ Where to fly
            </Typography>
          </Box>
          <Typography>
            Fly into <strong>Denver International Airport</strong>.
          </Typography>
        </Box>

        {/* Where to stay section */}
        <Box sx={{ 
          bgcolor: 'white', 
          p: 2, 
          borderRadius: 2,
          mb: 4 
        }}>
          <Box sx={{ 
            bgcolor: 'rgba(225, 213, 203, 0.3)',
            p: 1,
            px: 2,
            borderRadius: 20,
            mb: 2,
            width: '100%'
          }}>
            <Typography 
              align="left"
              variant="h5" 
              component="h2"
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontWeight: 'bold'
              }}
            >
              🏠 Where to stay
            </Typography>
          </Box>
          
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>Hotels in Golden, Evergreen & Morrison:</strong>
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Comfort Golden West Suites Evergreen
            </Typography>
            <Typography variant="body2">
              29300 U.S. Highway 40<br />
              Evergreen, CO 80439<br />
              <Link 
                href="https://goldenwesternsuiteshotel.com/" 
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'primary.main' }}
              >
                Visit Website
              </Link>
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Origin Hotel Red Rocks
            </Typography>
            <Typography variant="body2">
              18485 W Colfax Ave<br />
              Golden, CO 80401<br />
              <Link 
                href="https://www.originhotel.com/hotels/red-rocks" 
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'primary.main' }}
              >
                Visit Website
              </Link>
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Hampton Inn Denver West/Golden
            </Typography>
            <Typography variant="body2">
              17150 U.S. Highway 40<br />
              Golden, CO 80401<br />
              <Link 
                href="https://www.hilton.com/en/hotels/dengohx-hampton-denver-west-golden/?SEO_id=GMB-AMER-HX-DENGOHX&y_source=1_MjA5MzM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D" 
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'primary.main' }}
              >
                Visit Website
              </Link>
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Holiday Inn Express & Suites Golden
            </Typography>
            <Typography variant="body2">
              17140 W Colfax Ave<br />
              Golden, CO 80401<br />
              <Link 
                href="https://www.ihg.com/holidayinnexpress/hotels/us/en/golden/dengolden/hoteldetail?cm_mmc=GoogleMaps-_-EX-_-US-_-DENGOLDEN" 
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'primary.main' }}
              >
                Visit Website
              </Link>
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            Alternate Lodging Options:
          </Typography>
          <Typography sx={{ mb: 2 }}>
            There are lots of Air BnB's and VRBO's in the area. We recommend staying somewhere in <strong>Evergreen</strong> or <strong>Golden</strong>, with easy access to the <strong>Hogback Park'n Ride (Dinosaur Lot)</strong>.
          </Typography>
        </Box>

        {/* Transportation section */}
        <Box sx={{ 
          bgcolor: 'white', 
          p: 2, 
          borderRadius: 2,
          mb: 4 
        }}>
          <Box sx={{ 
            bgcolor: 'rgba(225, 213, 203, 0.3)',
            p: 1,
            px: 2,
            borderRadius: 20,
            mb: 2,
            width: '100%'
          }}>
            <Typography 
              align="left"
              variant="h5" 
              component="h2"
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontWeight: 'bold'
              }}
            >
              🚗 Transportation in Denver
            </Typography>
          </Box>
          <Typography>
            Denver has fairly limited public transit. You can check out the{' '}
            <Link 
              href="https://www.rtd-denver.com/" 
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'primary.main' }}
            >
              RTD website
            </Link>
            {' '}to see what's available, but we recommend Uber, Lyft, or renting a car for ease of access to the Front Range and Mountains.
          </Typography>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            onClick={() => navigate('/rsvp')}
            sx={{
              mt: 3,
              mb: 4,
              px: 8,
              py: 1.5,
              borderRadius: 25,
              fontFamily: '"Open Sans", sans-serif',
              backgroundColor: 'rgba(175, 99, 42, 1)',
              color: '#fff',
              '&:hover': {
                backgroundColor: 'rgba(187, 138, 101, 1)',
              },
            }}
          >
            RSVP
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default Travel;
